// extracted by mini-css-extract-plugin
module.exports = {"select-label":"src-components-molecules-SelectLabel-___style__select-label___1KdgR","styled-select":"src-components-molecules-SelectLabel-___style__styled-select___2FG3R"};